import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Configuration } from 'generated-sources/openapi';
import { AuthGuard } from './auth.guard';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  title = 'response.life.edu';
  loggedIn = false;
  isAdmin = false;
  role: string;

  constructor(private authGuard: AuthGuard, private cfg: Configuration, private router: Router) { }

  ngOnInit(): void {
    this.authGuard.token$.subscribe((r) => {
      this.loggedIn = !!r;
      if (this.loggedIn) {
        // this.groups = r.groups;
        // this.isAdmin = this.groups.indexOf('admins') !== -1;
        this.role = r.role;
        this.isAdmin = this.role === 'admin';
      } else {
        this.role = null;
        this.isAdmin = false;
      }
    });
  }

  signOut(): void {
    this.authGuard.updateToken(null);
    window.localStorage.removeItem('login');
    this.cfg.accessToken = null;
    this.router.navigate(['/login']);
  }
}
